module.exports = __webpack_public_path__ + "img/celPhone-icon.f9d62edd.svg";